import React from "react";
import { Col, Container, Row, Card } from "react-bootstrap";
import classes from "./Auth.module.css";
import { Link } from "react-router-dom";
import cogoToast from "cogo-toast";
import { authForgotPassword } from "../../network/auth";
import { useMutation } from "@tanstack/react-query";
import { Form, Input, Button} from "antd";
import { useTranslation } from "react-i18next";

const ForgotPassword = () => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const { mutate: onForgotPassword, isPending } = useMutation({
    mutationFn: (formData) => authForgotPassword(formData),
    onSuccess: (data) => {
      cogoToast.success(data.message);
      form.resetFields();
    },
    onError: () => {
      cogoToast.warn(t("auth.errorMessage"), { position: "top-right" });
    },
  });

  const onFinish = (values) => {
    onForgotPassword(values);
  };

  return (
      <Container>
        <Row>
          <Col className="mx-auto py-5" xl={8} lg={8} md={8} sm={12}>
            <h4 className={`${classes["auth-header-title"]}`}>
              Forgot Password.
            </h4>
            <h6 className={`${classes["auth-subheader-title"]}`}>
              Already member?{" "}
              <Link to="/login" className={`${classes["register-link"]}`}>
                Login
              </Link>{" "}
              here.
            </h6>

            <Card className={`${classes["custom-card"]}`}>
              <Card.Body>
                <Row>
                  <Col></Col>
                  <Col xl={8}>
                    <Form
                      form={form}
                      name="forgotPassword"
                      onFinish={onFinish}
                      layout="vertical"
                    >
                      <Form.Item
                        required={false}
                        name="email"
                        label={t("login3")}
                        rules={[
                          { type: 'email', message: t("auth.emailValidation") },
                          { required: true, message: t("auth.emailValidationRequired") },
                        ]}
                      >
                        <Input placeholder={t("login3")} />
                      </Form.Item>

                      <Button loading={isPending} type="primary" htmlType="submit"  className={`${classes["auth-button"]}`}>
                      {t("submit")}
                    </Button>
                    </Form>
                  </Col>
                  <Col></Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
  );
}

export default ForgotPassword;
